// 定义秒，分，小时，天的转化常量
var SECOND = 1000;
var MINUTE = 60 * SECOND;
var HOUR = 60 * MINUTE;
var DAY = 24 * HOUR; // 把毫秒解析成TimeDataType格式

export function parseTime(time) {
  var days = Math.floor(time / DAY);
  var hours = Math.floor(time % DAY / HOUR);
  var minutes = Math.floor(time % HOUR / MINUTE);
  var seconds = Math.floor(time % MINUTE / SECOND);
  var milliseconds = Math.floor(time % SECOND);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    milliseconds: milliseconds
  };
} // 把TimeDataType解析成毫秒

export function unParseTime(time) {
  var _time$days = time.days,
      days = _time$days === void 0 ? 0 : _time$days,
      _time$hours = time.hours,
      hours = _time$hours === void 0 ? 0 : _time$hours,
      _time$minutes = time.minutes,
      minutes = _time$minutes === void 0 ? 0 : _time$minutes,
      _time$seconds = time.seconds,
      seconds = _time$seconds === void 0 ? 0 : _time$seconds,
      _time$milliseconds = time.milliseconds,
      milliseconds = _time$milliseconds === void 0 ? 0 : _time$milliseconds;
  return days * DAY + hours * HOUR + minutes * MINUTE + seconds * SECOND + milliseconds;
} // 判断是否在浏览器中运行

export var inBrowser = typeof window !== 'undefined'; // 判断跟元素

var root = inBrowser ? window : global; // 根据id清除对应的animationFrame

export function cancelRaf(id) {
  var cancelAnimationFrame = root.cancelAnimationFrame || root.clearTimeout;
  cancelAnimationFrame.call(root, id);
} // 计算现在时间

var prev = Date.now(); // requestAnimationFrame不存在时用setTimeout代替，得出id

function rafPolyfill(fn) {
  var curr = Date.now();
  var ms = Math.max(0, 16 - (curr - prev));
  var id = setTimeout(fn, ms);
  prev = curr + ms;
  return id;
} // 得到animationFrame的id


export function raf(fn) {
  var requestAnimationFrame = root.requestAnimationFrame || rafPolyfill;
  return requestAnimationFrame.call(root, fn);
} // 补0成需要的格式

export function padZero(num, targetLength) {
  if (targetLength === void 0) {
    targetLength = 2;
  }

  var str = "" + num;

  while (str.length < targetLength) {
    str = "0" + str;
  }

  return str;
} // 是否在秒级相等

export function isSameSecond(time1, time2) {
  return Math.floor(time1 / 1000) === Math.floor(time2 / 1000);
} // 根据传入的格式解析时间成特定格式

export function parseFormat(formatArg, currentTime) {
  var days = currentTime.days;
  var format = formatArg;
  var hours = currentTime.hours,
      minutes = currentTime.minutes,
      seconds = currentTime.seconds,
      milliseconds = currentTime.milliseconds;

  if (format.includes('DD')) {
    format = format.replace('DD', padZero(days));
  } else {
    hours += days * 24;
  }

  if (format.includes('HH')) {
    format = format.replace('HH', padZero(hours));
  } else {
    minutes += hours * 60;
  }

  if (format.includes('mm')) {
    format = format.replace('mm', padZero(minutes));
  } else {
    seconds += minutes * 60;
  }

  if (format.includes('ss')) {
    format = format.replace('ss', padZero(seconds));
  } else {
    milliseconds += seconds * 1000;
  }

  if (format.includes('S')) {
    var ms = padZero(milliseconds, 3);
    format = format.replace(/S{3}/, ms).replace(/S{2}/, ms.slice(0, 2)).replace(/S{1}/, ms.charAt(0));
  }

  return format;
}